// TODO: remove use of any
/* eslint-disable @typescript-eslint/no-explicit-any */
export enum Endian {
  LITTLE,
  BIG,
}

export type PromiseResolve = (value: any) => any;
export type PromiseReject = (error: Error) => any;
